import React from 'react'
import { Icon, l } from '@manychat/manyui'

import { SidebarHeader } from 'apps/aiAutomation/components/SidebarHeader/SidebarHeader'

import cm from './KnowledgeProcessing.module.css'

export const KnowledgeProcessing = () => (
  <section className="h-full">
    <SidebarHeader title={l.translate('Always-On Answers')} />
    <div className={cm.wrapper}>
      <div className={cm.content}>
        <Icon.Spinner className={cm.spinner} size={32} />

        <h3 className="m-t-sm text-subheading">
          {l.translate('AI is training from your knowledge…')}
        </h3>

        <p className="m-t-xxs">
          {l.translate('Once it’s finished, you’ll be able to enable Always-On Answers.')}
        </p>
      </div>
    </div>
  </section>
)
